<div class="craftnote-loader d-flex align-items-center h-100 w-100 position-absolute justify-content-center">
	<mat-spinner color="accent" [diameter]="40"></mat-spinner>
</div>
